import type { QueryKey } from "@tanstack/react-query";

/** Query-key factory for the staff Lead Generator roster. Reads register under
 *  `leadGeneratorKeys.all` so a mutation covers list + stats + detail with ONE
 *  prefix invalidation. */
export const leadGeneratorKeys = {
  all: ["lead-generators"] as const,
  list: (filters: Record<string, unknown>): QueryKey => [...leadGeneratorKeys.all, "list", filters],
  stats: (filters: Record<string, unknown>): QueryKey => [...leadGeneratorKeys.all, "stats", filters],
  detail: (id: string): QueryKey => [...leadGeneratorKeys.all, "detail", id],
};
